import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
export default class OtherContactService extends ApiService {
  namespace = "contact";
  template = "defaultTemplate";
  DOMAIN = 149;
  icon = "FolderUser";

  Width = 1000;
  action = "action";
  singular = this.terminology.privateContact.singular;
  plural = this.terminology.privateContact.plural;
  gemItems = [
    {
      key: "create",
      label: this.t("addAEntity", { entity: this.singular }),
      icon: PrimeIcons.PLUS_CIRCLE,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: PrimeIcons.LIST,
    },

    {
      key: "email",
      label: this.t("emailEntity", { entity: this.singular }),
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "report",
      label: this.t("generateReport"),
      icon: PrimeIcons.FILE_EXCEL,
    },
  ];

  columns = [
    {
      header: this.t("displayName"),
      icon: "UserSilhouette",
      field: "display_name",
    },

    {
      header: this.t("number"),
      icon: "Barcode",
      field: "number",
    },

    {
      header: this.t("contact"),
      icon: "UserSilhouette",
      field: "contact",
    },

    {
      header: this.t("phone"),
      icon: "Phone",
      field: "phone",
    },
    {
      header: "Fax",
      icon: "FAX",
      field: "fax",
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "editAnEntity",
      icon: PrimeIcons.LIST,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: -3,
      icon: PrimeIcons.LIST,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: PrimeIcons.ENVELOPE,
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: "Bullets",
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),

      icon: "Bookmark",
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: "Disable",
    },
  ];
  filterItems = [
    { name: "Status", key: "status", value: "2", realm: "2" },
    { name: "Date", key: "date", value: "3", realm: "1" },
    { name: "Due Date", key: "due", value: "4", realm: "0" },
  ];

  constructor() {
    super("private-contacts");
  }
}
